<template>
  <ts-loading-banner :loading="update_imei_loading">
    <div class="row">
      <div class="col-md-12 form-group">
        <label class="ts-text-xs">{{ $t('productProfile.serial#') }}</label>
        <input
          type="text"
          v-model="model.serial_no"
          class="form-control"
          readonly
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 form-group">
        <label class="ts-text-xs required">{{
          $t('productProfile.frameCode')
        }}</label>
        <input
          type="text"
          v-model.trim="model.imei"
          class="form-control"
          :class="{ 'is-invalid': errors.has('imei') }"
        />
        <div class="invalid-feedback ts-text-xs" v-if="errors.has('imei')">
          {{ errors.first('imei') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 form-group">
        <label class="ts-text-xs">{{
          $t('productProfile.engineNumber')
        }}</label>
        <input type="text" v-model="model.engine_number" class="form-control" />
        <div class="validate" v-if="errors.has('engine_number')">
          {{ errors.first('engine_number') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 form-group">
        <label class="ts-text-xs required">{{
          $t('productProfile.cost')
        }}</label>
        <input
          type="text"
          v-model.number="model.cost"
          class="form-control"
          :class="{ 'is-invalid': errors.has('cost') }"
        />
        <div class="validate" v-if="errors.has('cost')">
          {{ errors.first('cost') }}
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="ts-text-xs required">{{
            $t('productProfile.color')
          }}</label>
          <Select
            class="ts-w-full"
            v-model="model.color"
            filterable
            allow-create
            @on-create="handleCreate"
          >
            <Option
              v-for="(item, index) in colors"
              :value="item.color"
              :key="index"
              >{{ item.color }}</Option
            >
          </Select>
          <div class="validate" v-if="errors.has('color')">
            {{ errors.first('color') }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 form-group">
        <label class="ts-text-xs">{{ $t('productProfile.plateNumber') }}</label>
        <input type="text" v-model="model.plate_number" class="form-control" />
        <div class="validate" v-if="errors.has('plate_number')">
          {{ errors.first('plate_number') }}
        </div>
      </div>
      <div class="col-md-6 form-group">
        <label class="ts-text-xs">{{ $t('productProfile.mcNumber') }}</label>
        <input type="text" v-model="model.mc_number" class="form-control" />
        <div class="validate" v-if="errors.has('mc_number')">
          {{ errors.first('mc_number') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 form-group">
        <label class="ts-text-xs">{{
          $t('productProfile.yearOfManifacture')
        }}</label>
        <input
          type="text"
          v-model.number="model.year_of_m"
          class="form-control"
        />
        <div class="validate" v-if="errors.has('year_of_m')">
          {{ errors.first('year_of_m') }}
        </div>
      </div>
      <div class="col-md-6 form-group">
        <div class="form-group">
          <label class="ts-text-xs">{{
            $t('productProfile.steeringWheel')
          }}</label>
          <Select
            class="ts-w-full"
            v-model="model.steering_wheel"
            filterable
            allow-create
            @on-create="createSteeringWheel"
          >
            <Option
              v-for="(item, index) in steeringWheels"
              :value="item.steering_wheel"
              :key="index"
              >{{ item.steering_wheel }}</Option
            >
          </Select>
          <div class="validate" v-if="errors.has('steering_wheel')">
            {{ errors.first('steering_wheel') }}
          </div>
        </div>
      </div>
      <div class="col-md-6 form-group">
        <div class="form-group">
          <label class="ts-text-xs">{{
            $t('productProfile.vehicleRegistrationDate')
          }}</label>
          <DatePicker
            v-model="model.vehicle_registration_date"
            placement="bottom-end"
            style="width: 100%"
            :transfer="true"
            format="dd-MM-yyyy"
            @on-change="onChangeVehicleRegistrationDate"
          ></DatePicker>
          <div
            class="text-danger"
            v-if="errors.has('vehicle_registration_date')"
          >
            {{ errors.first('vehicle_registration_date') }}
          </div>
        </div>
      </div>
      <div class="col-md-6 form-group">
        <label class="ts-text-xs">{{ $t('productProfile.issuedBy') }}</label>
        <input type="text" v-model="model.issued_by" class="form-control" />
        <div class="validate" v-if="errors.has('issued_by')">
          {{ errors.first('issued_by') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 form-group">
        <label class="ts-text-xs">{{ $t('productProfile.remark') }}</label>
        <textarea
          rows="3"
          class="form-control"
          v-model="model.qc_remarks"
        ></textarea>
        <div class="validate" v-if="errors.has('qc_remarks')">
          {{ errors.first('qc_remarks') }}
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>
<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
  name: 'CarUpdateSerial',
  props: ['value', 'update_imei_loading'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('product/profile', ['colors', 'steeringWheels'])
  },
  methods: {
    handleCreate(val) {
      this.colors.push({
        value: val,
        color: val
      })
    },
    createSteeringWheel(val) {
      this.steeringWheels.push({
        value: val,
        steering_wheel: val
      })
    },
    onChangeVehicleRegistrationDate(date) {
      this.model.vehicle_registration_date = date
    }
  }
}
</script>
